import { Box } from '@/components/box';
import { Text } from '@/components/text';
import { VimeoPlayer } from '@/components/vimeo-player';
import { VideoCarousel } from '@/types/sanity';
import { SliderComposeable } from '../../core/slider-composeable';

const config = {
  slides: {
    perView: 1.5,
    spacing: 30,
  },
  breakpoints: {
    '(min-width: 768px)': {
      slides: {
        perView: 2.5,
        spacing: 30,
      },
    },
  },
};

type VideoSliderProps = {
  slides: VideoCarousel['slides'];
};

export function VideoSlider({ slides }: VideoSliderProps) {
  if (!Array.isArray(slides)) {
    return null;
  }

  return (
    <>
      <SliderComposeable
        css={{
          paddingLeft: '$4',
          paddingRight: '$4',
          '@bp3': {
            paddingLeft: 'calc($6 + calc(100vw / 16))',
            paddingRight: '$6',
          },
          '@bp4': {
            paddingLeft: 'calc($8 + calc(100vw / 16))',
            paddingRight: 'calc($9 - $2)',
          },
        }}
        config={config}
        slides={slides.map((slide) => {
          const { shouldAutoplay, shouldLoop, shouldHideControls, videoId } =
            slide.vimeo;

          return (
            <Box
              css={{
                display: 'flex',
                flexDirection: 'column',
                gap: '$5',
              }}
              key={`video-slider-${videoId}`}
            >
              <VimeoPlayer
                videoId={videoId}
                autoplay={shouldAutoplay}
                loop={shouldLoop}
                controls={!shouldHideControls}
                muted={false}
              />

              <Text size="3">{slide.description}</Text>
            </Box>
          );
        })}
      />
    </>
  );
}
